import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * NativeSelect - Uses native HTML <select> for maximum compatibility
 * Works in all browsers including in-app browsers (Instagram, Facebook, etc.)
 */
export const NativeSelect = ({ 
  value, 
  onChange, 
  options, 
  placeholder = "Sélectionner",
  className = "",
  "data-testid": dataTestId,
  required = false
}) => {
  return (
    <div className="relative">
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full h-10 px-3 pr-8 rounded-md border bg-transparent text-white appearance-none cursor-pointer border-white/20 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold/50 ${!value ? 'text-gray-500' : 'text-white'} ${className}`}
        data-testid={dataTestId}
        required={required}
      >
        <option value="" disabled className="bg-[#1a1a2e] text-gray-400">
          {placeholder}
        </option>
        {options.map(opt => (
          <option 
            key={opt.value} 
            value={opt.value}
            className="bg-[#1a1a2e] text-white"
          >
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" />
    </div>
  );
};

export default NativeSelect;
